import axios from "axios";
import { getAccessToken, getReservoirApiUrl } from "../services/vu";
import { getPreviewModeEnabled } from "./liveview";

//Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (
      response.headers.group &&
      response.headers.group.toLowerCase() === "staff"
    ) {
      window.location =
        "https://myvuportal.vu.edu.au/uPortal/f/staff_myvuhome/normal/render.uP";
    }
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export const getJsonApiData = (urlPath, options = {}) => {
  return getReservoirApiUrl(`jsonapi/${urlPath}`)
    .then(reservoirApiUrl => get(reservoirApiUrl, options))
    .then(response => response.data);
};

export const getJsonApi = (urlPath, options = {}) => {
  return getReservoirApiUrl(`jsonapi/${urlPath}`).then(reservoirApiUrl =>
    get(reservoirApiUrl, options)
  );
};

// export const getJsonApiData = (urlPath, options = {}) => {
//   return get(`jsonapi/${urlPath}`, options)
//     .then(response => response.data)
// }
//
// export const getJsonApi = (urlPath, options = {}) => {
//   return get(`jsonapi/${urlPath}`, options)
// }

export const get = (urlPath, options = {}) => {
  return getAccessToken().then(accessToken => {
    return axios
      .get(
        urlPath,
        Object.assign({}, options, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
      )
      .then(response => response.data)
      .catch(err => {
        console.log(err);
      });
  });
};

export const getModalsBySlug = slug =>
  getJsonApi("node/modal", {
    params: {
      "filter[field_slug][value]": slug
    }
  });

export const getPagesBySlug = (slug, cohort = null) => {
  let params = {
    include: "field_background_image",
    "filter[field_slug][value]": slug
  };
  if (!getPreviewModeEnabled()) {
    params["filter[status][value]"] = 1;
  }

  if (cohort) {
    params["filter[field_cohort.field_test][value]"] = cohort;
  }

  return getJsonApi("node/page", {
    params: params
  });
};

export const getHelperTextForPage = pageName => {
  return getJsonApiData("node/enrol_helper", {
    params: {
      "filter[field_enrol_page_name.name][value]": pageName
    }
  });
};

export const getSliderItemById = sliderItemId => {
  const cacheName = `SLIDER_ITEM_${sliderItemId}`;

  if (!sessionStorage.getItem(cacheName)) {
    return getJsonApi(`node/week_info/${sliderItemId}`).then(data => {
      if (data) {
        sessionStorage.setItem(cacheName, JSON.stringify(data));
      }
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(cacheName)));
  });
};

export const getWeekLinks = (
  weekUuid,
  cohort,
  collegeName,
  calendarType,
  location,
  userRole,
  status = null
) => {
  const cacheName = `WEEK_LINKS_${cohort}_${collegeName}_${calendarType}_${location}_${weekUuid}`;

  if (!sessionStorage.getItem(cacheName)) {
    let params = {
      "filter[field_week.id][value]": weekUuid,
      "filter[field_cohorts.field_test][value]": cohort,

      "filter[or-group-calendar-type][group][conjunction]": "OR",
      "filter[specific-calendar-type][condition][path]":
        "field_cal_type.field_machine_name.value",
      "filter[specific-calendar-type][condition][value]": calendarType,
      "filter[specific-calendar-type][condition][memberOf]":
        "or-group-calendar-type",
      "filter[both-calendar-types][condition][path]":
        "field_all_calendar_types",
      "filter[both-calendar-types][condition][value]": 1,
      "filter[both-calendar-types][condition][memberOf]":
        "or-group-calendar-type",

      "filter[or-group-location][group][conjunction]": "OR",
      "filter[specific-location][condition][path]":
        "field_locations.field_location_code",
      "filter[specific-location][condition][value]": location,
      "filter[specific-location][condition][memberOf]": "or-group-location",
      "filter[all-locations][condition][path]": "field_all_locations",
      "filter[all-locations][condition][value]": 1,
      "filter[all-locations][condition][memberOf]": "or-group-location"
    };

    if (!getPreviewModeEnabled()) {
      params["filter[status][value]"] = 1;
    }

    return getJsonApiData("node/week_links", {
      params: {
        ...params,
        ...getCollegeParams(collegeName, userRole)
      }
    }).then(data => {
      sessionStorage.setItem(cacheName, JSON.stringify(data));
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(cacheName)));
  });
};

const getCollegeParams = (collegeName, userRole) => {
  if (collegeName) {
    return {
      "filter[or-group-college][group][conjunction]": "OR",
      "filter[specific-college][condition][path]":
        userRole === "EDITOR" || userRole === "REVIEWER"
          ? "field_college.field_college_code"
          : "field_college.field_teaching_units.field_code",
      "filter[specific-college][condition][value]": collegeName,
      "filter[specific-college][condition][memberOf]": "or-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "or-group-college"
    };
  } else {
    return {
      "filter[and-group-college][group][conjunction]": "AND",
      "filter[specific-college][condition][path]": "field_all_colleges",
      "filter[specific-college][condition][operator]": "<>",
      "filter[specific-college][condition][value]": 0,
      "filter[specific-college][condition][memberOf]": "and-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][operator]": "=",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "and-group-college"
    };
  }
};



export const getTransportVictoriaPage = date => {
  
  let cacheName = "TRANSPORT_VICTORIA";
  if (!sessionStorage.getItem(cacheName)) {

    return getJsonApiData("node/transport_victoria", {
        params: {
          "filter[date-between-group][group][conjunction]": "AND",
          "filter[start_range][condition][path]": "field_tv_start_date",
          "filter[start_range][condition][operator]": "<=",
          "filter[start_range][condition][value]": date,
          "filter[start_range][condition][memberOf]": "date-between-group",
          "filter[end-date-or-group][group][conjunction]": "OR",
          "filter[date-greater][condition][path]": "field_tv_end_date",
          "filter[date-greater][condition][operator]": ">",
          "filter[date-greater][condition][value]": date,
          "filter[date-greater][condition][memberOf]": "end-date-or-group",
          "filter[date-not-null][condition][path]": "field_tv_end_date",
          "filter[date-not-null][condition][operator]": "IS NULL",
          "filter[date-not-null][condition][memberOf]": "end-date-or-group",
          "filter[end-date-or-group][condition][memberOf]": "date-between-group"
        }
      }).then(data => {
        sessionStorage.setItem(cacheName, JSON.stringify(data));
        return data;
      });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(cacheName)));
  });
};

export const getHamburgerLinks = (cohort, locationCode) => {
  let cacheName = "hamburger_menu_" + cohort + "_" + locationCode;

  if (!sessionStorage.getItem(cacheName)) {
    let params = {
      sort: "field_placement_position",
      "filter[field_cohorts.field_test][value]": cohort,
      "filter[or-group-location][group][conjunction]": "OR",
      "filter[specific-location][condition][path]":
        "field_locations.field_location_code",
      "filter[specific-location][condition][value]": locationCode,
      "filter[specific-location][condition][memberOf]": "or-group-location",
      "filter[generic-locations][condition][path]": "field_all_locations",
      "filter[generic-locations][condition][value]": 1,
      "filter[generic-locations][condition][memberOf]": "or-group-location"
    };

    if (!getPreviewModeEnabled()) {
      params["filter[status][value]"] = 1;
    }

    return getJsonApiData("node/hamburger_menu", {
      params: params
    }).then(data => {
      sessionStorage.setItem(cacheName, JSON.stringify(data));
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(cacheName)));
  });
};

export const getAllTilesPreview = (
  week,
  category = false,
  locationName = "",
  cohort = false,
  collegeName = false,
  hasBlockStatus = false,
  courseAttemptStatus = false,
  calendarType = false,
  userRole = null
) => {
  return getTilesPage(
    week,
    category,
    locationName,
    cohort,
    collegeName,
    hasBlockStatus,
    courseAttemptStatus,
    calendarType,
    userRole,
    0,
    null
  ).then(defaultTilesResponse => {
    const validStates = ["draft", "published"];

    defaultTilesResponse.data = defaultTilesResponse.data.filter(tile =>
      validStates.includes(tile.attributes.moderation_state)
    );

    return resolveDefaultDataToWorkingCopyByModerationState(
      defaultTilesResponse.data,
      validStates
    ).then(workingCopyData => {
      defaultTilesResponse.data = workingCopyData;
      return defaultTilesResponse;
    });
  });
};

export const getAllTiles = (
  week,
  category = false,
  locationName = "",
  cohort = false,
  collegeName = false,
  hasBlockStatus = false,
  courseAttemptStatus = false,
  calendarType = false,
  userRole = null
) => {
  return getTilesPage(
    week,
    category,
    locationName,
    cohort,
    collegeName,
    hasBlockStatus,
    courseAttemptStatus,
    calendarType,
    userRole
  );
};

export const resolveDefaultDataToWorkingCopyByModerationState = (
  defaultDataArray,
  [validModerationStates]
) => {
  //Create requests to retrieve working copies if available
  const workingCopyRequests = defaultDataArray
    .filter(dataItem => dataItem.links["working-copy"] != null)
    .map(dataItem => dataItem.links["working-copy"]["href"])
    .map(url => get(url));

  return Promise.all(workingCopyRequests)
    .then(workingCopyResponses => {
      //Filter working copies to only those in valid moderation states
      return workingCopyResponses
        .map(item => item.data)
        .filter(dataItem =>
          validModerationStates.includes(dataItem.attributes.moderation_state)
        );
    })
    .then(workingDataArray => {
      //Combine defaultData with workingCopy data (replacing the former where appropriate)
      return defaultDataArray.map(defaultDataItem => {
        const workingDataItem = workingDataArray.find(
          workingDataItem => workingDataItem.id == defaultDataItem.id
        );
        return workingDataItem != null ? workingDataItem : defaultDataItem;
      });
    });
};

export const resolveDefaultDataToWorkingCopyByUnpublished = defaultDataArray => {
  //Create requests to retrieve working copies if available
  const workingCopyRequests = defaultDataArray
    .filter(dataItem => dataItem.links["working-copy"] != null)
    .map(dataItem => dataItem.links["working-copy"]["href"])
    .map(url => get(url));

  return Promise.all(workingCopyRequests)
    .then(workingCopyResponses => {
      //Filter working copies to only those that are unpublished
      return workingCopyResponses
        .map(item => item.data)
        .filter(dataItem => (dataItem.attributes.status = null));
    })
    .then(workingDataArray => {
      //Combine defaultData with workingCopy data (replacing the former where appropriate)
      return defaultDataArray.map(defaultDataItem => {
        const workingDataItem = workingDataArray.find(
          workingDataItem => workingDataItem.id == defaultDataItem.id
        );
        return workingDataItem != null ? workingDataItem : defaultDataItem;
      });
    });
};

export const getTiles = (
  week,
  category = false,
  locationName = "",
  cohort = false,
  collegeName = false,
  hasBlockStatus = false,
  courseAttemptStatus = false,
  calendarType = false,
  currentOffset = 0,
  status = 1,
  userRole = null
) => {
  return getJsonApi("node/tile", {
    params: getParamsForTiles(
      week,
      category,
      locationName,
      cohort,
      collegeName,
      hasBlockStatus,
      courseAttemptStatus,
      calendarType,
      currentOffset,
      status,
      userRole
    )
  });
};

export const getTilesPage = (
  week,
  category = false,
  locationName = "",
  cohort = false,
  collegeName = false,
  hasBlockStatus = false,
  courseAttemptStatus = false,
  calendarType = false,
  userRole = null,
  currentOffset = 0,
  status = 1
) => {
  return getTiles(
    week,
    category,
    locationName,
    cohort,
    collegeName,
    hasBlockStatus,
    courseAttemptStatus,
    calendarType,
    currentOffset,
    status,
    userRole
  ).then(({ data = [], included = [], links }) => {
    if (links.hasOwnProperty("next")) {
      const offsetSize = 50;

      return getTilesPage(
        week,
        category,
        locationName,
        cohort,
        collegeName,
        hasBlockStatus,
        courseAttemptStatus,
        calendarType,
        userRole,
        currentOffset + offsetSize,
        status
      ).then(offsetedTiles => {
        return {
          data: data.concat(offsetedTiles.data),
          included: included.concat(offsetedTiles.included)
        };
      });
    }

    return {
      data,
      included
    };
  });
};

const getParamsForTiles = (
  week,
  category = false,
  locationName = "",
  cohort = false,
  collegeName = false,
  hasBlockStatus = false,
  courseAttemptStatus = false,
  calendarType = false,
  currentOffset = 0,
  status = 1,
  userRole = null
) => {
  let params = {
    include: "field_photo,field_tile_type,field_cohorts"
  };

  if (status) {
    params["filter[status][value]"] = 1;
  }

  if (category) {
    params = Object.assign(params, {
      "filter[field_tile_type.name][value]": category
    });
  }

  if (locationName) {
    params = Object.assign(params, {
      "filter[or-loc][group][conjunction]": "OR",
      "filter[spec-loc][condition][path]": "field_location.name",
      "filter[spec-loc][condition][value]": locationName,
      "filter[spec-loc][condition][memberOf]": "or-loc",
      "filter[gen-loc][condition][path]": "field_all_locations",
      "filter[gen-loc][condition][value]": 1,
      "filter[gen-loc][condition][memberOf]": "or-loc"
    });
  }

  // if (courseAttemptStatus === 'INTERMIT' || courseAttemptStatus === 'COMPLETED') {
  //   return Object.assign(params, {
  //     'filter[or-week][group][conjunction]': 'OR',
  //     'filter[spec-week][condition][path]': 'field_week.name',
  //     'filter[spec-week][condition][value]': 'Week 99',
  //     'filter[spec-week][condition][memberOf]': 'or-week',
  //     'filter[gen-week][condition][path]': 'field_all_weeks_',
  //     'filter[gen-week][condition][value]': 1,
  //     'filter[gen-week][condition][memberOf]': 'or-week',
  //   })
  // }

  params = Object.assign(params, {
    "filter[or-week][group][conjunction]": "OR",
    "filter[spec-week][condition][path]": "field_week.id",
    "filter[spec-week][condition][value]": week,
    "filter[spec-week][condition][memberOf]": "or-week",
    "filter[gen-week][condition][path]": "field_all_weeks_",
    "filter[gen-week][condition][value]": 1,
    "filter[gen-week][condition][memberOf]": "or-week"
  });

  if (calendarType) {
    params = Object.assign(params, {
      "filter[or-caltype][group][conjunction]": "OR",
      "filter[spec-caltype][condition][path]":
        "field_calendar_.field_machine_name.value",
      "filter[spec-caltype][condition][value]": calendarType,
      "filter[spec-caltype][condition][memberOf]": "or-caltype",
      "filter[both-caltype][condition][path]": "field_all_calendar_types",
      "filter[both-caltype][condition][value]": 1,
      "filter[both-caltype][condition][memberOf]": "or-caltype"
    });
  }

  // params = Object.assign(params, {
  //   'filter[or-group-model][group][conjunction]': 'OR',
  //   'filter[specific-model][condition][path]': 'field_model_type',
  //   'filter[specific-model][condition][value]': firstYearModel ? 'FYM' : 'SEM',
  //   'filter[specific-model][condition][memberOf]': 'or-group-model',
  //   'filter[generic-models][condition][path]': 'field_model_type',
  //   'filter[generic-models][condition][value]': 'BOTH',
  //   'filter[generic-models][condition][memberOf]': 'or-group-model'
  // })

  if (cohort) {
    params = Object.assign(params, {
      "filter[or-cohort][group][conjunction]": "OR",
      "filter[spec-cohort][condition][path]": "field_cohorts.field_test",
      "filter[spec-cohort][condition][value]": cohort,
      "filter[spec-cohort][condition][memberOf]": "or-cohort",
      "filter[gen-cohort][condition][path]": "field_all_cohorts",
      "filter[gen-cohort][condition][value]": 1,
      "filter[gen-cohort][condition][memberOf]": "or-cohort"
    });
  } else {
    params = Object.assign(params, {
      "filter[and-cohort][group][conjunction]": "AND",
      "filter[spec-cohort][condition][path]": "field_all_cohorts",
      "filter[spec-cohort][condition][operator]": "<>",
      "filter[spec-cohort][condition][value]": 0,
      "filter[spec-cohort][condition][memberOf]": "and-cohort",
      "filter[gen-cohort][condition][path]": "field_all_cohorts",
      "filter[gen-cohort][condition][operator]": "=",
      "filter[gen-cohort][condition][value]": 1,
      "filter[gen-cohort][condition][memberOf]": "and-cohort"
    });
  }

  params = Object.assign(params, getCollegeParams(collegeName, userRole));

  if (currentOffset > 0) {
    params["page[offset]"] = currentOffset;
  }

  return params;
};

export const getTileByUuid = tileUuid => {
  return getJsonApi(`node/tile/${tileUuid}`, {
    params: {
      include: "field_photo,field_tile_type"
    }
  });
};

export const getNotifications = (cohort, collegeName, calendarType = null) => {
  let params = {
    "filter[field_cohorts.field_test][value]": cohort,
    "filter[status][value]": 1
  };

  if (calendarType) {
    params = {
      ...params,
      "filter[or-group-calendar-type][group][conjunction]": "OR",
      "filter[specific-calendar-type][condition][path]":
        "field_cal_type.field_machine_name.value",
      "filter[specific-calendar-type][condition][value]": calendarType,
      "filter[specific-calendar-type][condition][memberOf]":
        "or-group-calendar-type",
      "filter[both-calendar-types][condition][path]":
        "field_all_calendar_types",
      "filter[both-calendar-types][condition][value]": 1,
      "filter[both-calendar-types][condition][memberOf]":
        "or-group-calendar-type"
    };
  }

  if (collegeName) {
    params = Object.assign(params, {
      "filter[or-group-college][group][conjunction]": "OR",
      // The field in Drupal is field_collage
      "filter[specific-college][condition][path]":
        "field_collage.field_teaching_units.field_code",
      "filter[specific-college][condition][value]": collegeName,
      "filter[specific-college][condition][memberOf]": "or-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "or-group-college"
    });
  } else {
    params = Object.assign(params, {
      "filter[and-group-college][group][conjunction]": "AND",
      "filter[specific-college][condition][path]": "field_all_colleges",
      "filter[specific-college][condition][operator]": "<>",
      "filter[specific-college][condition][value]": 0,
      "filter[specific-college][condition][memberOf]": "and-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][operator]": "=",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "and-group-college"
    });
  }

  return getJsonApiData("node/notifications", {
    params: params
  });
};

export const getNotificationsByWeek = (
  week,
  cohort,
  collegeName,
  calendarType
) => {
  let params = {
    "filter[status][value]": 1,
    "filter[field_week.id][value]": week,
    "filter[field_cohorts.field_test][value]": cohort,

    "filter[or-group-calendar-type][group][conjunction]": "OR",
    "filter[specific-calendar-type][condition][path]":
      "field_cal_type.field_machine_name.value",
    "filter[specific-calendar-type][condition][value]": calendarType,
    "filter[specific-calendar-type][condition][memberOf]":
      "or-group-calendar-type",
    "filter[both-calendar-types][condition][path]": "field_all_calendar_types",
    "filter[both-calendar-types][condition][value]": 1,
    "filter[both-calendar-types][condition][memberOf]": "or-group-calendar-type"
  };

  if (collegeName) {
    params = Object.assign(params, {
      "filter[or-group-college][group][conjunction]": "OR",
      // The field in Drupal is field_collage
      "filter[specific-college][condition][path]":
        "field_collage.field_teaching_units.field_code",
      "filter[specific-college][condition][value]": collegeName,
      "filter[specific-college][condition][memberOf]": "or-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "or-group-college"
    });
  } else {
    params = Object.assign(params, {
      "filter[and-group-college][group][conjunction]": "AND",
      "filter[specific-college][condition][path]": "field_all_colleges",
      "filter[specific-college][condition][operator]": "<>",
      "filter[specific-college][condition][value]": 0,
      "filter[specific-college][condition][memberOf]": "and-group-college",
      "filter[generic-colleges][condition][path]": "field_all_colleges",
      "filter[generic-colleges][condition][operator]": "=",
      "filter[generic-colleges][condition][value]": 1,
      "filter[generic-colleges][condition][memberOf]": "and-group-college"
    });
  }

  return getJsonApiData("node/notifications", {
    params: params
  });
};

export const getTooltipBySlug = slug => {
  return getJsonApiData("node/tooltip", {
    params: {
      "filter[field_slug][value]": slug
    }
  });
};

export const getTooltipsForPage = pageName => {
  return getJsonApiData("node/tooltip", {
    params: {
      "filter[field_myvu_page.name][value]": pageName
    }
  });
};

export const getTileTypes = () => {
  const tileTypeName = `TILE_TYPE`;

  if (!sessionStorage.getItem(tileTypeName)) {
    return getJsonApiData("taxonomy_term/tile_type").then(data => {
      sessionStorage.setItem(tileTypeName, JSON.stringify(data));
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem(tileTypeName)));
  });
};

export const getCampusLocations = () => {
  let params = {};
  if (!getPreviewModeEnabled()) {
    params["filter[status][value]"] = 1;
  }

  if (sessionStorage.getItem("campus_location")) {
    // console.log('pulling from storage: campus location')
    return new Promise(resolve => {
      resolve(JSON.parse(sessionStorage.getItem("campus_location")));
    });
  }

  return getJsonApiData("taxonomy_term/location", {
    params: params
  }).then(data => {
    //console.log('campus location API', data)
    sessionStorage.setItem("campus_location", JSON.stringify(data));
    return data;
  });
};

export const getColleges = () => {
  if (sessionStorage.getItem("college")) {
    // console.log('pulling from storage: campus location')
    return new Promise(resolve => {
      resolve(JSON.parse(sessionStorage.getItem("college")));
    });
  }

  return getJsonApiData("taxonomy_term/college").then(data => {
    // console.log('campus location API', data)
    sessionStorage.setItem("college", JSON.stringify(data));
    return data;
  });
};

export const getCalendarTypes = () => {
  if (sessionStorage.getItem("calendar_types")) {
    // console.log('pulling from storage: campus location')
    return new Promise(resolve => {
      resolve(JSON.parse(sessionStorage.getItem("calendar_types")));
    });
  }

  return getJsonApiData("taxonomy_term/calendar_type").then(data => {
    // console.log('campus location API', data)
    sessionStorage.setItem("calendar_types", JSON.stringify(data));
    return data;
  });
};

export const getCourseAttemptStatus = () => {
  if (sessionStorage.getItem("course_attempt_status")) {
    return new Promise(resolve => {
      resolve(JSON.parse(sessionStorage.getItem("course_attempt_status")));
    });
  }

  return getJsonApiData("taxonomy_term/course_attempt_status").then(data => {
    // console.log('campus location API', data)
    sessionStorage.setItem("course_attempt_status", JSON.stringify(data));
    return data;
  });
};

export const getWeekType = () => {
  if (!sessionStorage.getItem("WEEK_TYPE_TAX")) {
    // console.log('pulling from storage: week_type')
    return getJsonApiData("taxonomy_term/week_type").then(data => {
      // console.log('week type API', data)
      sessionStorage.setItem("WEEK_TYPE_TAX", JSON.stringify(data));
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem("WEEK_TYPE_TAX")));
  });
};

export const getWeekTypeById = weekTypeId => {
  if (sessionStorage.getItem("week_type_" + weekTypeId)) {
    return getJsonApiData(`taxonomy_term/week_type/${weekTypeId}`).then(
      data => {
        sessionStorage.setItem("week_type_" + weekTypeId, JSON.stringify(data));
        return data;
      }
    );
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem("week_type_" + weekTypeId)));
  });
};

export const getCohortTypes = () => {
  if (!sessionStorage.getItem("COHORT_TAX")) {
    // console.log('pulling from storage: week_type')

    return getJsonApiData("taxonomy_term/cohort", {
      params: {
        sort: "-weight"
      }
    }).then(data => {
      sessionStorage.setItem("COHORT_TAX", JSON.stringify(data));
      return data;
    });
  }

  return new Promise(resolve => {
    resolve(JSON.parse(sessionStorage.getItem("COHORT_TAX")));
  });
};

export const getNavigationMenuList = () => {
  if (sessionStorage.getItem("menu_list")) {
    // console.log('pulling from storage: campus location')
    return new Promise(resolve => {
      resolve(JSON.parse(sessionStorage.getItem("menu_list")));
    });
  }

  return getJsonApiData("taxonomy_term/menu_list").then(data => {
    // console.log('campus location API', data)
    sessionStorage.setItem(
      "menu_list",
      JSON.stringify(extractNavigationMenuItems(data))
    );

    return extractNavigationMenuItems(data);
  });
};

function extractNavigationMenuItems(menuList) {
  const navMenuList = []
  const menuMap = {}

  menuList.forEach(taxonomyDataItem => {
    const {
      id,
      attributes: { name },
      relationships
    } = taxonomyDataItem
    menuMap[id] = { id, name, child: [] }

    if (!relationships.field_parent_item.data) {
      navMenuList.push(menuMap[id])
    }
  })

  menuList.forEach(taxonomyDataItem => {
    const { id, relationships } = taxonomyDataItem
    const parentData = relationships.field_parent_item.data

    if (parentData) {
      const parent = menuMap[parentData.id]
      if (parent) {
        const newChildObj = { id, name: menuMap[id].name, grandChild: [] }

        if (relationships.field_child_item.data.length) {
          relationships.field_child_item.data.forEach(grandChildItem => {
            const grandChild = menuMap[grandChildItem.id]
            if (grandChild) {
              newChildObj.grandChild.push(grandChild)
            }
          })
        }

        parent.child.push(newChildObj)
      }
    }
  })

  return navMenuList
}

export const findCohort = cohort => {
  //console.log('cohort %o', cohort)
  return getCohortTypes().then(cohortTax => {
    return cohortTax.find(item => {
      //console.log(item)
      if (item.attributes.field_test.find(field => field === cohort)) {
        //console.log('cohort found %o', item)
        return item;
      }
    });
  });
};

export const getIconsByCohort = cohort =>
  getJsonApiData(`node/icons`, {
    params: {
      "filter[field_cohort.field_test][value]": cohort
    }
  });

export const getHamburgerMenuLink = (cohort, location) => {
  let params = {
    include: "field_cohort,field_nested_links",
    sort: "field_sort_order",
    "filter[field_cohort.field_test][value]": cohort,

    "filter[or-group-location][group][conjunction]": "OR",
    "filter[specific-location][condition][path]":
      "field_locations.field_location_code",
    "filter[specific-location][condition][value]": location,
    "filter[specific-location][condition][memberOf]": "or-group-location",
    "filter[all-locations][condition][path]": "field_all_locations",
    "filter[all-locations][condition][value]": 1,
    "filter[all-locations][condition][memberOf]": "or-group-location"
  };

  if (!getPreviewModeEnabled()) {
    params["filter[status][value]"] = 1;
  }

  return getJsonApi("node/hamburger_menu_links_/", {
    params: params
  });
};

export const searchTiles = (query, admissionCategory = "") => {
  let params = {
    query: query,
    _format: "json"
  };
  if (admissionCategory) {
    params["admissionCategory"] = admissionCategory;
  }

  return getReservoirApiUrl("search/tiles").then(reservoirApiUrl =>
    get(reservoirApiUrl, {
      params: params
    })
  );
};

export const searchPages = (query, admissionCategory = "") => {
  let params = {
    query: query,
    _format: "json"
  };
  if (admissionCategory) {
    params["admissionCategory"] = admissionCategory;
  }

  return getReservoirApiUrl("search/pages").then(reservoirApiUrl =>
    get(reservoirApiUrl, {
      params: params
    })
  );
};

export const getRelatedPagesByTaxonomyId = (taxonomyId, cohort) => {
  return getJsonApiData("node/article", {
    params: {
      "filter[field_related_page.id][value]": taxonomyId,
      "filter[field_related_cohort.field_test][value]": cohort
    }
  });
};

export const getArticleById = taxonomyId => {
  return getJsonApiData("node/article/" + taxonomyId);
};

export const getFinanceLinks = admissionCategory => {
  let params = {
    "filter[field_cohort.field_test][value]": admissionCategory
  };
  if (!getPreviewModeEnabled()) {
    params["filter[status][value]"] = 1;
  }

  return getJsonApiData("node/finance_link", {
    params: params
  });
};

export const getCourseLinks = (admissionCategory, locationcode) => {
  let params = {
    "filter[field_cohort.field_test][value]": admissionCategory,
    "filter[or-group-location][group][conjunction]": "OR",
    "filter[specific-location][condition][path]":
      "field_locations.field_location_code",
    "filter[specific-location][condition][value]": locationcode,
    "filter[specific-location][condition][memberOf]": "or-group-location",
    "filter[all-locations][condition][path]": "field_all_locations",
    "filter[all-locations][condition][value]": 1,
    "filter[all-locations][condition][memberOf]": "or-group-location"
  };

  if (!getPreviewModeEnabled()) {
    params["filter[status][value]"] = 1;
  }

  return getJsonApiData("node/course_link", {
    params: params
  });
};

export const getReplaceStudentPlanIdentifier = (
  hyperLink,
  userId,
  courseId,
  versionNo,
  attemptNo
) => {
  hyperLink = hyperLink.replace(
    "$STDPLNID_MYVU$",
    userId + "." + courseId + "." + versionNo + "." + attemptNo
  );

  return hyperLink;
};

export const getFinanceSupportLeadText = (fundings, admissionCategory) => {
  let localAdmissionCategory = "NOT_DEFINED";

  let fundingParams = {};

  if (fundings.potentialFundingType.length) {
    localAdmissionCategory = admissionCategory !== "TAFE" ? "NOT_TAFE" : "TAFE";

    fundings.potentialFundingType.map((fundingInfo, index) => {
      let key1 = `filter[specific-government_assist-${index}][condition][path]`
      let key2 = `filter[specific-government_assist-${index}][condition][value]`;
      let key3 = `filter[specific-government_assist-${index}][condition][memberOf]`;
      fundingParams = {
        ...fundingParams,
        [key1]: "field_fs_government_assistance.field_gaf_status_code",
        [key2]: fundingInfo.status,
        [key3]: "or-group-government_assistance"
      }
    })
  }

  let params = {
    "filter[field_fs_admission_categories.field_ac_code][value]=": localAdmissionCategory,
    "filter[or-group-government_assistance][group][conjunction]": "OR",
    "filter[field_fs_all_government_assist][condition][path]": "field_fs_all_government_assist",
    "filter[field_fs_all_government_assist][condition][value]": 1,
    "filter[field_fs_all_government_assist][condition][memberOf]": "or-group-government_assistance",
    ...fundingParams
  }

  return getJsonApiData('node/finance_support_lead_text', {
    params: params
  })
}

export const getFinanceSupportContent = (funding, useAdditionalFilter = false, citizenshipCode, lcCode, course) => {
  let params = {
    'filter[field_fs_type][value]': funding.fundingType
  }

  if (useAdditionalFilter) {
    let tfnStatus = "Not Submitted";

    if (course.taxFileNumberStatus && course.taxFileNumberStatus.toLowerCase() === 'valid') { 
      tfnStatus = "Valid";
    }

    params = {
      ...params,
      "filter[field_government_assistance_stat.field_gaf_status_code][value]": funding.status,
      "filter[or-group-lc][group][conjunction]": "OR",
      "filter[specific-lc][condition][path]": "field_fs_liability_category.field_lc_code",
      "filter[specific-lc][condition][value]": lcCode,
      "filter[specific-lc][condition][memberOf]": "or-group-lc",
      "filter[all-lcs][condition][path]": "field_fs_all_lcs",
      "filter[all-lcs][condition][value]": 1,
      "filter[all-lcs][condition][memberOf]": "or-group-lc",
      "filter[or-group-citizenship][group][conjunction]": "OR",
      "filter[specific-citizenship][condition][path]": "field_fs_citizenship.field_citizenship_code",
      "filter[specific-citizenship][condition][value]": citizenshipCode,
      "filter[specific-citizenship][condition][memberOf]": "or-group-citizenship",
      "filter[all-citizenship][condition][path]": "field_fs_all_citizenships",
      "filter[all-citizenship][condition][value]": 1,
      "filter[all-citizenship][condition][memberOf]": "or-group-citizenship",
      "filter[or-group-tfn][group][conjunction]": "OR",
      "filter[specific-tfn][condition][path]": "field_fs_tfn_status.field_tfs_code",
      "filter[specific-tfn][condition][value]": tfnStatus,
      "filter[specific-tfn][condition][memberOf]": "or-group-tfn",
      "filter[requires-tfn][condition][path]": "field_fs_requires_tfn",
      "filter[requires-tfn][condition][value]": 0,
      "filter[requires-tfn][condition][memberOf]": "or-group-tfn"
    }

  }

  return getJsonApiData('node/finance_support', {
    params: params
  })
}

export const getFinanceSupportFormLink = id => {
  return getJsonApiData('node/cia_links', {
    params: {
      'filter[field_id][value]': id
    }
  })  
}

export const getStudentSanctionContentBySanctionType = sanctionType => {
  return getJsonApiData('node/student_sanctions', {
    params: {
      'filter[field_sanction_hold.field_sanction_type][condition][path]': 'field_sanction_hold.field_sanction_type', // Filter by the sanction type
      'filter[field_sanction_hold.field_sanction_type][value]': sanctionType
    }
  })
}

export const getTemporaryCustomMessages = id => {
  return getJsonApiData('node/temporary_messages').then(response => {
    const now = new Date()

    return response
      .filter(item => {
        const { field_message_date_range, field_temp_message_id, status } = item.attributes
        const start = new Date(field_message_date_range.value)
        const end = new Date(field_message_date_range.end_value)

        return now >= start && now <= end && status // ✅ keep only active
      })
      .filter(item => {
        return item.attributes.field_temp_message_id === id
      })
      .map(item => {
        const { title, body, field_temp_message_id } = item.attributes

        return {
          id: field_temp_message_id,
          title,
          value: body.value
        }
      })
  })
}